/**
 * region for libraries*/
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { Grid, Typography, Card, CardContent, Divider, Button, Dialog, DialogTitle, DialogActions } from '@material-ui/core';

/**
 * region for components*/
import { ResearchList } from './ResearchList';

/**
 * region for helpers*/
import ajax from '../../../helpers/ajax';
import typing from '../../../helpers/typing';
import list from '../../../helpers/list';

/**
 * region for constans*/
import Constants from '../../../constants/Constants'

export class ResearchKeywordSelection extends Component {
    static displayName = ResearchKeywordSelection.name;

    constructor(props) {
        super(props);

        this.state = {
            value: '',
            suggestions: [],
            keywordsLoaded: [],
            keywordsAdded: [],
            showResearchList: false,
            showModalKeywordsAdded: false
        };
    }

    getSuggestionValue = suggestion => suggestion.DESCRIPTION;

    renderSuggestion(suggestion) {
        return <div>{suggestion.DESCRIPTION}</div>
    }

    loadKeywordsByCategories(event, suggestion) {
        event.preventDefault();
        const self = this;

        let requestData = {
            idCategory: suggestion.IDCATEGORY
        };

        ajax.get(Constants.ROUTE_API_CATEGORIES_KEYWORDS_BY_CATEGORY,
            {
                requestData: requestData,
                success: function (response) {
                    self.setState({
                        mode: Constants.MODE_LOADED,
                        keywordsLoaded: response.data
                    });
                }
            });
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue,
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        const self = this;

        let requestdata = {
            term: value
        };

        ajax.get(Constants.ROUTE_API_CATEGORIES_AUTOCOMPLETE,
            {
                requestData: requestdata,
                success: function (response) {
                    self.setState({ suggestions: response.data })
                }
            });      
    }

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    handleShowResearchList() {
        this.setState({
            showResearchList: true
        });
    }

    handleCloseModal() {
        
        this.setState({
            showModalKeywordsAdded: false,
            value: '',
            keywordsLoaded: [],
            keywordsAdded: []
        });
    }

    handleShowModalAddedKeywords() {

        const self = this;

        let idKeywordList = this.state.keywordsAdded.map(keyword => keyword.IDKEYWORD);
           
        const requestData = {
            keywords: idKeywordList
        };

        ajax.put(Constants.ROUTE_API_RESEARCH_TASK,
            {
                requestData: requestData,
                success: function () {
                    self.setState({
                        showModalKeywordsAdded: true
                    });
                }
            });

    }

    handleAddKeyword(keyword, event) {
        event.preventDefault();
        const self = this;

        let keywordsAdded = typing.clone(self.state.keywordsAdded);
        let keywordsLoaded = typing.clone(self.state.keywordsLoaded);

        let indexBykeywordsLoaded = list.getIndex(keywordsLoaded, x => x.IDKEYWORD === keyword.IDKEYWORD);

        if (indexBykeywordsLoaded >= 0) {
            keywordsLoaded.splice(indexBykeywordsLoaded, 1);
        }

        keywordsAdded.push(keyword);

        self.setState({
            keywordsLoaded: keywordsLoaded,
            keywordsAdded: keywordsAdded
        });
    }

    handleRemoveKeyword(keyword, event) {
        event.preventDefault();
        const self = this;

        let keywordsLoaded = typing.clone(self.state.keywordsLoaded);
        let keywordsAdded = typing.clone(self.state.keywordsAdded);

        let index = list.getIndex(keywordsAdded, list => list.IDKEYWORD === keyword.IDKEYWORD);

        if (index >= 0) {
            keywordsAdded.splice(index, 1);
        }

        keywordsLoaded.push(keyword);

        self.setState({
            keywordsAdded: keywordsAdded,
            keywordsLoaded: keywordsLoaded
        });
    }

    handleAddAllKeywords() {
        const self = this;

        let keywordsToAdd = typing.clone(self.state.keywordsLoaded.filter(keyword => keyword.KEYWORD_PROCESSED_LAST_90_DAYS !== 1));
        let keywordsLoaded = typing.clone(self.state.keywordsLoaded.filter(keyword => keyword.KEYWORD_PROCESSED_LAST_90_DAYS === 1));
        let keywordsAdded = typing.clone(self.state.keywordsAdded);

        let keywordsAddedAll = keywordsAdded.concat(keywordsToAdd);

        self.setState({
            keywordsAdded: keywordsAddedAll,
            keywordsLoaded: keywordsLoaded
        });
    }

    handleRemoveAllKeywords() {
        const self = this;

        let keywordsLoaded = typing.clone(self.state.keywordsLoaded);
        let keywordsAdded = typing.clone(self.state.keywordsAdded);

        let keywordsRemoveAll = keywordsLoaded.concat(keywordsAdded);

        self.setState({
            keywordsAdded: [],
            keywordsLoaded: keywordsRemoveAll
        });
    }

    render() {

        const { value } = this.state;

        const inputProps = {
            placeholder: 'Subcategory',
            value,
            onChange: this.onChange
        };

        let categoriesToAdd = this.state.keywordsLoaded.map(keyword => {
            
            var spanStyle = null;
            
            if (keyword.KEYWORD_PROCESSED_LAST_90_DAYS)
                spanStyle = { color: 'LightGrey' };

            return (<li key={keyword.IDKEYWORD} className="mb-1"><button type="button" disabled={keyword.KEYWORD_PROCESSED_LAST_90_DAYS} className="btn btn-sm btn-outline-warning mr-1" onClick={this.handleAddKeyword.bind(this, keyword)}>
                <i className="fas fa-plus"></i> </button><span style={spanStyle}>{keyword.KEYWORD}</span></li>)
        });

        let categoriesToRemove = this.state.keywordsAdded.map(keyword =>
            <li key={keyword.IDKEYWORD} className="mb-1"><button type="button" className="btn btn-sm btn-outline-secondary mr-1" onClick={this.handleRemoveKeyword.bind(this, keyword)}>
                <i className="fas fa-times"></i> </button>{keyword.KEYWORD}</li>)
            
        let showModal;
        if (this.state.showModalKeywordsAdded) {
            showModal = <Dialog open={this.state.showModalKeywordsAdded}
                                onClose={this.handleCloseModal.bind(this)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description">
                                <DialogTitle id="alert-dialog-title"><i className="material-icons mr-1 mt-1 done-icon">done</i>Added {this.state.keywordsAdded.length} keywords to the research queue</DialogTitle>
                                <DialogActions>
                                <Button className="mb-2 mr-1" variant="contained" color="primary" onClick={this.handleCloseModal.bind(this)}>OK</Button>
                            </DialogActions>
                        </Dialog>
        }

        let researchKeywords;
        if (this.state.showResearchList) {
            researchKeywords = <ResearchList />
        } else {
            researchKeywords = <div className="container mt-2">
                <Grid item container direction="row" spacing={2}>
                    <Grid item md>
                        <Autosuggest className="w-100 form-control mb-2"
                                    suggestions={this.state.suggestions}
                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
                                    getSuggestionValue={this.getSuggestionValue.bind(this)}
                                    renderSuggestion={this.renderSuggestion.bind(this)}
                                    onSuggestionSelected={(event, suggestion) => {
                                        this.loadKeywordsByCategories(event, suggestion.suggestion);
                                    }}
                                    inputProps={inputProps} />
                    </Grid>
                    <Grid item md>
                        <Typography variant="h6">
                            Keywords to research
                        </Typography>
                    </Grid>
                </Grid>
                <Grid className="mb-1" item container direction="row" spacing={2}>
                    <Grid item md>
                        <Card className="card card-keyword">
                            <CardContent>
                                <ul className="list-unstyled list-services">
                                    {categoriesToAdd}
                                </ul>
                            </CardContent>
                        </Card>
                        <Button variant="contained" className="mt-1" onClick={this.handleAddAllKeywords.bind(this)}>
                            Add all
                        </Button>
                    </Grid>
                    <Grid item md>

                        <Card className="card card-keyword">
                            <CardContent>
                                <ul className="list-unstyled list-services">
                                    {categoriesToRemove}
                                </ul>
                               
                            </CardContent>
                        </Card>
                        <Button variant="contained" className="mt-1" onClick={this.handleRemoveAllKeywords.bind(this)}>
                            Remove all
                        </Button>
                    </Grid>
                </Grid>
                <Divider />
                <Grid container justify="flex-end" >
                    <Button variant="contained" color="primary" className="mt-1" onClick={this.handleShowModalAddedKeywords.bind(this)}>GO</Button>
                </Grid>
                {showModal}
            </div> 
        }

        return (
            <div className="research-keyword-container">
                {researchKeywords}
            </div>
        );
    }
}
